import React from "react";
import ReceivedTransferPreview from "../../localTransfer/components/ReceivedTransferPreview";
import { NEARBY_TRANSFER_STATES } from "../nearbyTransfer.constants";
import {
  ConnectedDeviceCard,
  DeviceList,
  IncomingPairCard,
  PanelIcon,
  SavedAttachmentNotice,
  StatusPill,
  TransferProgress,
  WaitingCard,
} from "./NearbyNetpadsViews";

const isPairingStatus = (status) =>
  [
    NEARBY_TRANSFER_STATES.REQUESTING_PAIR,
    NEARBY_TRANSFER_STATES.INCOMING_PAIR,
    NEARBY_TRANSFER_STATES.PAIRING,
  ].includes(status);

const NearbyNetpadsPanel = ({
  className = "",
  hasSavedAttachment,
  hasSelectedFile,
  onOpenReceivedTransfer,
  session,
}) => {
  const { actions, deviceIdentity, state } = session;

  const handleOpenReceivedTransfer = (receivedTransfer) => {
    onOpenReceivedTransfer(receivedTransfer);
    actions.clearReceivedTransfer();
  };

  const renderConnectionBody = () => {
    if (state.status === NEARBY_TRANSFER_STATES.FAILED) {
      return (
        <WaitingCard
          text={state.errorMessage || "Nearby transfer needs attention."}
        />
      );
    }
    if (state.status === NEARBY_TRANSFER_STATES.OFFLINE) {
      return <WaitingCard text="Connecting to Nearby Netpads..." />;
    }
    if (state.status === NEARBY_TRANSFER_STATES.CONNECTING) {
      return <WaitingCard text="Looking for nearby devices..." />;
    }
    if (state.status === NEARBY_TRANSFER_STATES.REQUESTING_PAIR) {
      return <WaitingCard text="Waiting for the other device to accept pairing." />;
    }
    if (state.status === NEARBY_TRANSFER_STATES.PAIRING) {
      return <WaitingCard text="Pairing devices over the local network..." />;
    }
    if (state.status === NEARBY_TRANSFER_STATES.TRANSFERRING) {
      return <TransferProgress progress={state.transferProgress} />;
    }
    if (state.incomingPairRequest) {
      return (
        <IncomingPairCard
          onAccept={actions.acceptPair}
          onDecline={actions.declinePair}
          request={state.incomingPairRequest}
        />
      );
    }
    if (state.isChannelConnected) {
      return (
        <ConnectedDeviceCard
          connectedDevice={state.connectedDevice}
          isTransferring={state.status === NEARBY_TRANSFER_STATES.TRANSFERRING}
          onDisconnect={actions.disconnect}
          onSend={actions.sendCurrentTransfer}
          pairingCode={state.pairingCode}
        />
      );
    }

    return (
      <DeviceList
        devices={state.devices}
        isPairing={isPairingStatus(state.status)}
        onPair={actions.requestPair}
      />
    );
  };

  return (
    <section className={`rounded-md border border-border bg-surface p-3 font-montserrat shadow-sm ${className}`}>
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <PanelIcon />
            <h2 className="text-base font-bold text-text">Nearby Netpads</h2>
          </div>
          <p className="mt-1 truncate text-xs text-text-muted">
            This device: {deviceIdentity.deviceName}
          </p>
        </div>
        <StatusPill
          isConnected={state.isChannelConnected}
          status={state.status}
        />
      </div>
      <div className="flex flex-col gap-3">
        <SavedAttachmentNotice
          hasSavedAttachment={hasSavedAttachment}
          hasSelectedFile={hasSelectedFile}
        />
        {state.receivedTransfer && (
          <ReceivedTransferPreview
            onClose={actions.clearReceivedTransfer}
            onOpen={handleOpenReceivedTransfer}
            receivedTransfer={state.receivedTransfer}
          />
        )}
        {renderConnectionBody()}
      </div>
    </section>
  );
};

export default NearbyNetpadsPanel;
